export const apiRequests = {
    reqActiLogin,
    reqLoginZabbix,
    reqProblemsZabbix,
    reqHostsZabbix,
    reqApplicationsZabbix,
    reqItensZabbix,
    reqTriggerZabbix,
    reqActiveTriggersZabbix,
    reqSiteLocZabbix,
    reqEventsZabbix,
    reqAcknowledgeEventZabbix,
    reqItemHistoryZabbix,
    reqChangeEntity,
    createTicket,
    relateEquipment,
    solveTicket,
    drawConsumable,
    updateConsumable,
    addConsumable,
    addConsumables,
    approveTicket,
    AddTicketFollowUp,
    AddTicketTask,
    denyTicket,
    AddTicketCost,
    updateTicket
};

//*******ACTI Requests********


//Basic Login
function reqActiLogin(username, password) {
    // Create Base64 Object
    // Define the string
    var string = username+":"+password;
    // Encode the String
    var encodedString = btoa(string);

    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json", "Authorization":"Basic "+ encodedString},
        // body: JSON.stringify({ username, password })
    };

    return requestOptions;
}

//Change Entity
function reqChangeEntity( entity) {
    const requestOptions = {"entities_id": entity, "is_recursive": true};

    return requestOptions;
}

//Create Ticket
function createTicket( title,content,status,urgency,priority,type,category) {
    const requestOptions = {
      "input":
        { "name": title,
        "content": content,
        "status": status,
        "priority": priority,
        "type": type,
        "urgency": urgency,
        "itilcategories_id":category,
        "requesttypes_id":59}
      };

    return requestOptions;
}


//Update Ticket
function updateTicket( id,ticketInfo) {
    const requestOptions =
      {"input": [{"id": id,
      "itemtype": "ticket",
      "date":ticketInfo.begin_date.replace("T", " ")+":00",
      "update":"Salvar", }] };

    return requestOptions;
}

//Solve Ticket
function solveTicket( id,solution, materials,ticketInfo) {
    const requestOptions =
      {"input": [{"id": id,
      "itemtype": "ticket",
      "materiais": materials,
      "date":ticketInfo.begin_date.replace("T", " ")+":00",
      "global_validation": 1,
      "validation_percent": 0,
      "update":"Salvar", }] };

    return requestOptions;
}

//Solve Ticket
function approveTicket( id) {
    const requestOptions =
      {"input": [{"id": id,
      "status": 6, }] };

    return requestOptions;
}



//Solve Ticket
function denyTicket( id, approvalPercent) {
    const requestOptions =
      {"input": [{"id": id,
      "status": 2,
      "global_validation": 1,
      "validation_percent": approvalPercent, }] };

    return requestOptions;
}

//Solve Ticket
function AddTicketFollowUp( id, comment) {
    const requestOptions =
      {"input": [{"tickets_id": id,
      "content": comment, }] };

    return requestOptions;
}



//Solve Ticket
function AddTicketTask( id, user_id, actiontime,date_begin,date_end) {
    const requestOptions =
      {"input": [{"tickets_id": id,
      "users_id": user_id,
      "users_id_tech": user_id,
      "content": "ACOMPANHAMENTO",
      "tasktemplates_id": 88,
      "taskcategories_id": 9,
      "state": 2,
      "actiontime": actiontime,
      "begin": date_begin.replace("T", " "),
      "end": date_end.replace("T", " ") }] };

    return requestOptions;
}

//Add Ticket Cost
function AddTicketCost(id,name,comment,actiontime,cost_time,cost_fixed,cost_materials) {
    const requestOptions =
      {"input": [{
        "tickets_id": id,
        "name": name,
        "comment": comment,
        "actiontime": actiontime,
        "cost_time": cost_time,
        "cost_fixed": cost_fixed,
        "cost_material": cost_materials
      }] };

    return requestOptions;
}
//Draw Consumable
function drawConsumable( id,date,consumableitems_id, items_id) {
    const requestOptions ={
    "id": id,
    "date_out":date,
    "consumableitems_id": consumableitems_id,
    "itemtype": "Group",
    "items_id": items_id };

    return requestOptions;
}

//Draw Consumable
function addConsumables( consumableitems_id) {
    const requestOptions ={
    "consumableitems_id": consumableitems_id,};

    return requestOptions;
}


//Update Consumable
function updateConsumable( id,name,ref, comment,date_creation,min,locations_id,manufacturers_id,consumableitemtypes_id) {
    const requestOptions ={
    "input":{
      "id": id,
      "name":name,
      "ref": ref,
      "comment": comment,
      "date_creation": date_creation,
      "alarm_threshold":min,
      "locations_id":locations_id,
      "manufacturers_id":manufacturers_id,
      "consumableitemtypes_id":consumableitemtypes_id,
      "itemtype": "consumableitem" }
    };

    return requestOptions;
}

//Update Consumable
function addConsumable( entity,name,ref, comment,min,type, location, manufacturer) {
    const requestOptions ={
    "input":{
      "entities_id": entity,
      "is_recursive": 1,
      "name":name,
      "ref": ref,
      "comment": comment,
      "alarm_threshold":min,
      "locations_id": location,
      "consumableitemtypes_id": type,
      "manufacturers_id": manufacturer,
      "itemtype": "consumableitem" }
    };

    return requestOptions;
}

//Relate Ticket with Equipment
function relateEquipment( itemtype,items_id,tickets_id) {
    const requestOptions = {
      "input":
        {"itemtype": itemtype,
        "items_id": items_id,
        "tickets_id": tickets_id }
      };

    return requestOptions;
}

//Token Auth header
function reqVDCLogin() {

  const requestOptions = {
      headers: { "Content-Type": "application/json",
      "Accept":"application/json",
      "Authorization": "Basic YWRtaW46R3JlZW40dDEyMw=="}
  };


    return requestOptions;
}

//******Zabbix Requests********

//Basic Auth Request
function reqLoginZabbix(username, password,id) {

    const requestOptions = {  "jsonrpc": "2.0",
                "method": "user.login",
                "params": {
                    "user": username,
                    "password": password
                },
                "id": id};

    return requestOptions;
}

//Problems Request
function reqProblemsZabbix(token) {

  const requestOptions = {"jsonrpc": "2.0",
                            "method": "problem.get",
                            "params": {
                              "output": [
                                  "acknowledged",
                                  "objectid",
                                  "eventid",
                                  "acknowledges",
                                  "clock",
                                  "ns"
                              ],
                                "selectAcknowledges": ["message","clock"],
                                "sortfield": ["eventid"],
                                "sortorder": "DESC"
                            },
                            "auth": token,
                            "id": 1
                        };

    return requestOptions;
}

//Events Request
function reqEventsZabbix(token,hostids,applicationids,time_from,time_till,id) {

  const requestOptions = {"jsonrpc": "2.0",
                            "method": "event.get",
                            "params": {
                              "output": ["objectid","eventid","clock","value","ns","acknowledged","source"],
                              "select_acknowledges": ["message","clock"],
                              "sortfield": ["eventid"],
                              "sortorder": "DESC",
                              "hostids": hostids,
                              "applicationids": applicationids,
                              "time_from": time_from,
                              "time_till": time_till,
                              "limit": 19999
                            },
                            "auth": token,
                            "id": id
                        };

    return requestOptions;
}

//Site location Request
function reqSiteLocZabbix(token, host, id) {

  const requestOptions = {"jsonrpc": "2.0",
                            "method": "host.get",
                            "params": {
                              "output": [
                                    "hostid",
                                    "host"
                                ],
                                "selectInventory": [
                                     "location_lat",
                                     "location_lon",
                                     "location"
                                 ],
                                 "withInventory": true,
                                "search": {
                                    "host": host
                                }
                            },
                            "id": id,
                            "auth": token
                        };

    return requestOptions;
}

//Hosts Request
function reqHostsZabbix(token, host,id) {

  const requestOptions = {"jsonrpc": "2.0",
                            "method": "host.get",
                            "params": {
                              "output": [
                                  "hostid",
                                  "host"
                              ],
                                "search": {
                                    "host": host
                                }
                            },
                            "id": id,
                            "auth": token
                        };

    return requestOptions;
}


//Applications Request
function reqApplicationsZabbix(token, hostid,id) {

  const requestOptions = {"jsonrpc": "2.0",
                            "method": "application.get",
                            "params": {
                                "output": [
                                    "applicationid",
                                    "name"
                                ],
                                "hostids": hostid,
                                "sortfield": "name",
                                "sortorder": "ASC"
                            },
                            "auth": token,
                            "id": id
                        };

    return requestOptions;
}

//Itens Request
function reqItensZabbix(token, hostid, applicationid, id) {

  const requestOptions = {"jsonrpc": "2.0",
                            "method": "item.get",
                            "params": {
                                "output": [
                                    "itemid",
                                    "name",
                                    "key_",
                                    "units",
                                    "lastvalue",
                                    "status"
                                ],
                                "hostids": hostid,
                                "applicationids": applicationid,
                                "search": {
                                    "_key": ""
                                },
                                "filter": {
                                    "status": "0"
                                },
                                "searchWildcardsEnabled": true,
                                "searchByAny": true,
                                "sortfield": "name",
                                "sortorder": "ASC"
                            },
                            "auth": token,
                            "id": id
                        };

    return requestOptions;
}

//Trigger Request
function reqTriggerZabbix(token, hostid, applicationid, itemid, id) {

  const requestOptions = {"jsonrpc": "2.0",
                            "method": "trigger.get",
                            "params": {
                              "output": [
                                    "triggerid",
                                    "description",
                                    "status",
                                    "value",
                                    "priority"
                                ],
                                "hostids": hostid,
                                "applicationids": applicationid,
                                "itemids":itemid
                            },
                            "auth": token,
                            "id": id
                        };

    return requestOptions;
}

//Active Triggers Request
function reqActiveTriggersZabbix(token, hostid) {

  const requestOptions = {"jsonrpc": "2.0",
                            "method": "trigger.get",
                            "params": {
                                "output": [
                                    "triggerid",
                                    "description",
                                    "status",
                                    "value",
                                    "priority"
                                ],
                                "hostids": hostid,
                                "filter": {
                                    "value": "1",
                                    "status": "0"
                                }
                            },
                            "auth": token,
                            "id": 1
                        };

    return requestOptions;
}

//Active Triggers Request
function reqAcknowledgeEventZabbix(token, eventsid, comment) {

  const requestOptions = { "jsonrpc": "2.0",
                            "method": "event.acknowledge",
                            "params": {
                                "eventids": eventsid,
                                "action": 6,
                                "message": comment
                            },
                            "auth": token,
                            "id": 1

                        };

    return requestOptions;
}

// Get Item Value History

function reqItemHistoryZabbix(token, itemids, time_from, limit) {

  const requestOptions = {  "jsonrpc": "2.0",
                            "method": "history.get",
                            "params": {
                                "itemids": itemids,
                                "sortfield": "clock",
                                "sortorder": "DESC",
                                "time_from": time_from,
                                "limit":limit
                            },
                            "auth": token,
                            "id": 1
                        };

    return requestOptions;
}
